import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { colors } from '../../../../colors'
import { SearchInput } from '../../../../components/input'

// import { Nav }

import{ search_icon } from '../../../../assets'



const HeroSection = () => {

    const [resources, setResources ] = useState()
    const [searchQuery, setSearchQuery] = useState()
    const [loading, setLoading] = useState()
    const [error, setError ] = useState()
    const [errorMessage, setErrorMessage] = useState()


    // useEffect(() => {
    //     let mounted = true;
    //     const getResourceByCategory = async () => {
    //       try {
    //         const response = await fetch(
                
    //             ("https://nigeriana-api-staging.herokuapp.com/api/v1/library/public/resources/search/?searchQuery=" +  searchQuery),
    //           {
    //             method: "GET",
    //             headers: {
    //               "Content-Type": "application/json",
    //             },
    //           }
    //         );
    //         const data = await response.json();
    //         setResources(data?.data?.results);
    //         console.log(setResources(data?.data?.results));
    //         setLoading(false);
    //       } catch (error) {
    //         setError(true);
    //         setErrorMessage(error?.message);
    //         setLoading(false);
    //       }
    //     };
    //     if (mounted) {
    //         getResourceByCategory();
            
    //     }
    //     return () => {
    //       mounted = false;
    //     }; 
    //   }, []);

    const onSubmit = (e) => {
        e.preventDefault()
    
        // navigate('/advanced-search')
      }
  return (
    <Container>
          
        <InnerContainer>
            {/* <h1>Join 200,000 fellow readers get to all text, images, videos from across Nigeria</h1> */}

            <h1>National virtual library of Nigeria <br />
              A gateway to available learning and information resources through a single platform.</h1>
            <SearchInput resource={resources} />

            {/* <InputContainer>

                    <img src={search_icon} alt="search icon" />

                    <form onSubmit={onSubmit} >
                        <input type="text" placeholder='Type in a search keyword' />
                        <Button>Search</Button>
                    </form>

          </InputContainer> */}
        </InnerContainer>

    </Container>
  )
}

const Container = styled.section`
    width: 100%;
    /* margin: 0 auto; */
    background-color: ${colors.primary};

`

const InnerContainer = styled.div`
    
    padding: 85px 0 100px;
    width: 60%;
    max-width: 1250px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    @media screen and (max-width: 450px){
        padding: 70px 0 70px;
        width: 80%;
    }

    & > h1{
        font-weight: 700;
        color: ${colors.white};
        text-align: center;

        @media screen and (max-width: 450px){
            font-weight: 500;
            font-size: 22px;
            line-height: 30px;
        }
    }
`

const InputContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 50%;
    height: 50px;
    /* justify-content: space-between; */
    align-items: center;
    background-color: ${colors.white};
    padding: 12px;
    border-radius: 4px;
    position: relative;
    margin-top: 10px;

    @media screen and (max-width: 600px){

      width: 90%;
      margin-top: 20px;
      padding: 12px;
    }

   
    & > form{

      

      & input{
        border: none;
        outline: none;
        padding: 10px;
        width: 100%;
        flex: 1;
        background-color: #fff;

        & :focus {
          background-color: #fff;
        }

        
    }


    }


`

const Button = styled.button`
    padding: 12px 27px;
        /* text-align: center; */
        width: fit-content;
        background-color: ${colors.secondary};
        border-radius: 0px 4px 4px 0px;
        border: none;
        position: absolute;
        right: 0%;
        bottom: 0%;
        align-self: center;
        font-size: 18px;
        height: 100%;
        font-weight: 600;
        color: ${colors.white};
        cursor: pointer;

        @media screen and (max-width: 600px){
          font-size: 14px;
          padding: 14px 6px;
          /* top: ; */
        }
`

export {HeroSection}